module.exports = __webpack_public_path__ + "img/image1.17dc906.png";